import { useContext, useEffect, useState } from "react";
import { CreateRetailSettingsDto } from "../../../../dtos/catalogs/RetailSettings/CreateRetailSettingsDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { PostTerminalDto } from "../../../../dtos/catalogs/RetailSettings/PostTerminalDto";
import RetailSettingsDetailSkeleton from "./RetailSettingsDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import RetailSettingsDetailMain from "./RetailSettingsDetailMain";

interface IProps {
  model: CreateRetailSettingsDto | null;
  modelUpdatedEvent: (newModel: CreateRetailSettingsDto) => void;
}

interface RetailSettingsModel {
  id?: string;
  name?: string;
  uniqueCode?: string;
  createdDate?: Date;
  warehouseId?: string;
  description?: string;
  customerId?: string;
  accountId?: string;
  priceTypeId?: string;
  connectedDeviceId?: string;
  posTerminals: PostTerminalDto[];
}

export const RetailSettingsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<RetailSettingsModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("warehouseId", model.warehouseId);
      setValue("description", model.description);
      setValue("customerId", model.customerId);
      setValue("accountId", model.accountId);
      setValue("priceTypeId", model.priceTypeId);
      setValue("connectedDeviceId", model.connectedDeviceId);
      setValue("posTerminals", model.posTerminals);
    }
  }, [model]);
  const handleFormSubmit = async (action: DocumentSaveActionType, data: RetailSettingsModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: CreateRetailSettingsDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
  };

  if (!model) {
    return (
      <>
        <RetailSettingsDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <RetailSettingsDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
